export default __webpack_public_path__ + "static/media/cafeteria.fd3488c7.jpg";